// ...existing code...
import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ApiService from "../../../network/ApiService";
import engToNepNumber from "../../../helpers/EngToNepNumber";
import { Lightbox } from "yet-another-react-lightbox";
import { Thumbnails } from "yet-another-react-lightbox/plugins";

function Notices(props) {
  const { organizationId } = useSelector((state) => state.organization);
  const api = useMemo(() => ApiService(), []); // instantiate once
  const { fetchNoticeUpdates } = api;

  const [noticeList, setNewsList] = useState([]);
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const languageStatus = sessionStorage.getItem("language");
  const [activeArray, setActiveArray] = useState(null);

  const normalizeListFromResponse = (data) =>
    data?.aboutUsNewsAndImg ??
    data?.noticeList ??
    data?.newsList ??
    data?.news ??
    data?.items ??
    [];

  const getNewsList = async () => {
    if (!fetchNoticeUpdates) return;
    try {
      const response = await fetchNoticeUpdates(organizationId);
      const data = response?.data ?? {};
      const list = normalizeListFromResponse(data);
      const arr = Array.isArray(list) ? list : [];
      setNewsList(arr);
      setActiveArray(arr.length > 0 ? arr[0] : null);
    } catch (error) {
      console.error(error?.message || error);
      setNewsList([]);
      setActiveArray(null);
    }
  };

  useEffect(() => {
    if (props.noticeList && props.noticeList.length > 0) {
      setNewsList(props.noticeList);
      setActiveArray(props.noticeList[0] ?? null);
      return;
    }
    if (organizationId) {
      getNewsList();
    }
  }, [organizationId, props.noticeList]); // api is memoized so not included

  const getActiveTab = (index) => {
    setActiveArray(noticeList[index] ?? null);
  };

  const parseHtmlToView = (str) => ({ __html: str ?? "" });

  const handleViewSlides = (galleryImages) => {
    if (!galleryImages) return;
    const imgs = Array.isArray(galleryImages) ? galleryImages : [galleryImages];
    const images = imgs.map((value) => ({
      src: value,
      alt: "image",
      width: 3840,
      height: 2560,
    }));
    setSlides(images);
    setOpen(true);
  };

  return (
    <>
      {window.location.pathname === "/notices" ? (
        <>
          {noticeList ? (
            <div className="tm-page">
              <div className="uk-section uk-section-default">
                <div className="uk-container">
                  <div className="tm-grid-expand">
                    <h2 className="uk-h2 uk-margin-large uk-text-center">
                      <span className="underline-secondary">
                        {languageStatus === "en" ? `Notices` : `सुचना/गतिविधि`}
                      </span>
                    </h2>
                  </div>
                  <div className={noticeList.length > 0 ? `uk-grid` : ""}>
                    <div className="uk-width-1-5@m">
                      <div className="uk-tab-left" uk-tab={`connect: #component-tab-left; animation: uk-animation-fade`}>
                        {noticeList.map((data, index) => (
                          <div key={`link_div_${index}`}>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                getActiveTab(index);
                              }}
                            >
                              {languageStatus === "en" ? (data.header ?? data.headerNp) : (data.headerNp ?? data.header)}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>

                    {activeArray ? (
                      <div className="uk-width-expand@m" key={`main_heading_${activeArray.id ?? activeArray.newsId ?? 0}`}>
                        <div id="component-tab-left">
                          <div uk-grid="true">
                            <div className="uk-width-expand@m">
                              <div className="uk-card uk-card-default uk-card-small uk-margin-remove-first-child uk-margin" data-id="page#7-0-1-1">
                                {activeArray.imageUrl && activeArray.imageUrl !== "n/a" && (
                                  <div className="uk-card-media-top">
                                    <div className="aspect-square" key={`image_${activeArray.id ?? activeArray.newsId ?? 0}`}>
                                      <img decoding="async" src={activeArray.imageUrl} className="el-image" alt="" loading="lazy" />
                                    </div>
                                  </div>
                                )}
                                <div className="uk-card-body uk-margin-remove-first-child" key={activeArray.id ?? activeArray.newsId ?? 0}>
                                  <h3 className="el-title uk-card-title uk-margin-top uk-margin-remove-bottom">
                                    {languageStatus === "en"
                                      ? (activeArray.headerEn ?? activeArray.header ?? activeArray.headerNp ?? "")
                                      : (activeArray.headerNp ?? activeArray.header ?? "")}
                                  </h3>
                                  <div
                                    className="el-content"
                                    style={{ color: "black" }}
                                    dangerouslySetInnerHTML={parseHtmlToView(
                                      (
                                        languageStatus === "en"
                                          ? (activeArray.message ?? activeArray.messageEn ?? activeArray.messageNp ?? "")
                                          : (activeArray.messageNp ?? activeArray.message ?? "")
                                      )
                                        .split("<p><br></p>")
                                        .join("")
                                    )}
                                  />
                                </div>

                                {Array.isArray(activeArray.galleryUrls) && activeArray.galleryUrls.length > 0 && (
                                  <div className="uk-flex uk-flex-column">
                                    <h3 className="uk-text-center">{languageStatus === "en" ? `Related Images` : "सम्बन्धित चित्रहरू"}</h3>
                                    <div className="uk-flex uk-flex-center uk-border-rounded">
                                      <Lightbox open={open} close={() => setOpen(false)} slides={slides} plugins={[Thumbnails]} carousel={{ finite: true }} />
                                      <div
                                        className="uk-card uk-column-span news-gallery-image uk-overflow-hidden uk-margin-small-bottom"
                                        style={{ cursor: "pointer", border: "1px solid #9E9E9E", padding: "5px", borderRadius: "5px" }}
                                        onClick={() => handleViewSlides(activeArray.galleryUrls)}
                                      >
                                        <img decoding="async" className="el-image" alt="" loading="lazy" src={activeArray.galleryUrls[0] ?? "assets/images/image.jpg"} />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div style={{ border: "1px solid", borderRadius: "5px", padding: "5px" }}>
                        <div className="uk-flex-wrap-bottom uk-text-bold" style={{ fontSize: "24px" }}>
                          {languageStatus === "en" ? `Notices Not Found` : `सुचना/गतिविधि भेटियन`}...
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <div className="uk-width-1-2@m uk-first-column">
          <h2 data-id="page#7-0-0-0" className="uk-margin-large uk-h2">
            <span className="underline-secondary">{props.language === "en" ? `Notices` : `सुचना/गतिविधि`}</span>
          </h2>
          {noticeList && noticeList.length > 0 ? (
            <div style={{ maxHeight: "520px", overflowY: "auto", paddingRight: "10px", border: "1px solid #ddd", borderRadius: "5px" }}>
              {noticeList.map((data, index) => (
                <div className="uk-card uk-card-default uk-card-small uk-card-body uk-margin-remove-first-child uk-margin" data-id="page#7-0-0-2" key={index}>
                  <h3 className="el-title uk-card-title uk-margin-top uk-margin-remove-bottom">
                    <Link to={`/news-detail/${data.newsId ?? data.id ?? index}`} style={{ color: "#2c3e94", textDecoration: "none" }}>
                      {props.language === "en" ? (data.header ?? data.headerNp) : (data.headerNp ?? data.header)}
                    </Link>
                  </h3>
                  <div className="el-meta uk-text-meta uk-margin-small">
                    {props.language === "en" ? (data.newsDateEn ?? data.newsDate ?? "") : engToNepNumber(data.newsDate ?? "")} &nbsp;
                    {props.language === "en"
                      ? (data.newsTime ?? "")
                      : (engToNepNumber((data.newsTime ?? "").split(" ")[0]) +
                          " " +
                          ((data.newsTime ?? "").split(" ")[1] ?? "").replace("AM", "बिहान").replace("PM", "बेलुका"))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ border: "1px solid", borderRadius: "5px", padding: "5px" }}>
              <div className="uk-flex-wrap-bottom uk-text-bold" style={{ fontSize: "24px" }}>
                {languageStatus === "en" ? `Notices Not Found` : `सुचना/गतिविधि भेटियन`}...
              </div>
            </div>
          )}
          {noticeList.length > 0 && (
            <div>
              <Link className="uk-link-reset" to="/notices">
                <button className="uk-button uk-button-primary">{props.language === "en" ? `View All` : `सबै हेर्नुहोस्`}</button>
              </Link>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default Notices;
// ...existing